module.exports = {
	extends: [
		'/',
		'base',
		'tabStrip',
		'tabStrip'
	],

	config: {
		closableTabs: false
	}
};